
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.665 18.19v.48a2.334 2.334 0 002.333 2.334H12a2.334 2.334 0 002.335-2.334v-.48"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M17.578 18.19a1.925 1.925 0 001.925-1.925v0c0-.54-.215-1.059-.596-1.441l-1.28-1.278V9.749A5.627 5.627 0 0012 4.122v0a5.627 5.627 0 00-5.627 5.627v3.797l-1.28 1.278c-.381.382-.596.9-.596 1.44v0c0 1.064.862 1.926 1.925 1.926h11.156v0z"}})])
          )
        }
      }
    